import axios from "axios";
import moment from "moment";

const apiUrl = process.env.REACT_APP_API_HOST;

const fetchData = async (endpoint, id) => {
  try {
    const { data } = await axios.get(`${apiUrl}${endpoint}/${id}`);
    return data;
  } catch (error) {
    console.error(`Error fetching data from ${apiUrl}${endpoint}/${id}`, error);
    throw error;
  }
};

export const getClientTrace = async (id, traceVersion) => {
  const url = traceVersion
    ? `/api/trace/getClientTrace/v${traceVersion}`
    : `/api/trace/getClientTrace`;

  return fetchData(url, id);
};

export const getTcDetailFoTrace = async (id) =>
  fetchData(`/api/tc/details/public`, id);

export const getVerifiedSteps = async (id) => {
  const res = await fetchData("/api/tc/verifyTc", id);
  const updatedSteps = res.data.steps.map((step) => ({
    ...step,
    isLoading: true,
  }));
  const updatedRes = { ...res, data: { ...res.data, steps: updatedSteps } };
  return updatedRes;
};

export const getLastVerifiedAtDate = async (id, traceVersion) => {
  const res = await fetchData(`/api/trace/getClientTrace/v${traceVersion}`, id);
  return moment
    .utc(res.data.Ginning[0].lastVerifiedAt)
    .local()
    .format("ddd DD MMM YYYY hh:mm:ss A z");
};

export const getTraceDetails = async (id) =>
  fetchData("/api/tc/details/public", id);
